module.exports = __webpack_public_path__ + "static/amethyst-0c85b5b13bcf66c46a4974a2574d5430.svg";